import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { User } from './user.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_user?: any;
  by_role?: any;
  by_activated_at?: any;
}

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
}
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiUrl = environment.apiEndpoint + 'users';
  private passwordRecoveryApiUrl = environment.apiEndpoint + 'password_recovery';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  getFilterCriteria() {
    const defaultParams: ExtendedDefaultParams = {
      // let defaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'first_name',
    };

    return defaultParams;
  }

  getUsers(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    const queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: this.utilService.cleanItemsCache(resp['data'], 'logo'),
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getUser(id: string, params = null): Observable<User> {
    const queryParams = new HttpParams({ fromObject: params });

    // If we want to update the obj
    return this.http
      .get<User>(`${this.apiUrl}/${id}`, {
        params: queryParams,
      })
      .pipe(
        map((resp) => {
          resp.logoUrl = this.utilService.cleanItemCache(resp, 'logo');
          return resp;
        })
      );
  }

  // Save / Update
  saveUser(userId: string, user: User, lang = '', photo = null): Observable<User> {
    const formData = new FormData();

    // Create and photo evaluated
    if (!userId && photo) {
      // Store form name as "file" with file data
      formData.append('file', photo, photo.name);
    }

    formData.append('lang', lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE);

    for (let key in user) {
      // Required when using new FormData
      if (Array.isArray(user[key])) {
        user[key].forEach((item) => formData.append('user[' + key + '][]', item));
      } else {
        formData.append('user[' + key + ']', user[key]);
      }
    }

    if (!userId) {
      return this.http.post<User>(`${this.apiUrl}`, formData);
    } else {
      return this.http.put<User>(`${this.apiUrl}/${userId}`, formData);
    }
  }

  updateUserLogo(userId, photo, updatePhoto): Observable<any> {
    const formData: FormData = new FormData();

    // Store form name as "file" with file data
    if (updatePhoto) {
      formData.append('file', photo, photo.name);
    } else {
      formData.append('file', photo);
    }

    formData.append('user[id]', userId);

    return this.http.put<User>(`${this.apiUrl}/${userId}`, formData);
  }

  saveUserPassword(userId, password): Observable<User> {
    const params = {
      password: password,
    };

    return this.http.put<User>(`${this.apiUrl}/${userId}`, { user: params });
  }

  checkUsername(username): Observable<any> {
    const url = `${environment.apiEndpoint}sessions/check_user_username?q=${username}`;
    return this.http.get(url);

    // Send apart in order to work special characters
    // const params = new HttpParams().set('q', username);
    // return this.http.get(url, { params });
  }

  sendRequestActivation(userId): Observable<any> {
    return this.http.put(`${this.apiUrl}/${userId}/request_activation`, {});
  }

  updateUserAppVersion(userId): Observable<any> {
    return this.http.put(`${this.apiUrl}/${userId}/update_version_number`, {});
  }

  activateUserAccount(token): Observable<any> {
    return this.http.put(`${this.apiUrl}/account_activation`, { token: token });
  }

  // Password recovery
  requestPaswordRecovery(data): Observable<any> {
    return this.http.post(`${this.passwordRecoveryApiUrl}`, { user: data });
  }

  checkPasswordRecovery(token, email): Observable<any> {
    // const url = `${environment.apiEndpoint}password_recovery/${token}?email=${email}`; // not working
    // const url = `${this.passwordRecoveryApiUrl}/${token}`;

    // Send apart in order to work special characters
    const params = new HttpParams().set('email', email);

    return this.http.get(`${this.passwordRecoveryApiUrl}/${token}`, { params });
  }

  savePasswordRecovery(data, token, email): Observable<any> {
    return this.http.put(`${this.passwordRecoveryApiUrl}/${token}`, { user: data, email: email });
  }

  // Move to register service maybe
  /*
  
  function registerUserAccount(user) {
      user['new_account_key'] = config.NEW_ACCOUNT_KEY;

      function success(response) {
        var msg = $translate('ACTIVATE_ACCOUNT_MSG');
        utils._setFlashMessage(msg);

        // $location.path('/login');

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request('post', apiUrl, user, success, failure);
    }

  
  */
}
